import { useContext } from 'react'

import { TravelTypeContext } from './TravelTypeContext'

export const useTravelTypeContext = () => useContext(TravelTypeContext)
